import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import type * as models from '../../models'
import * as fragments from '../fragments'

export const DOC = gql`
  ${fragments.user.DOC}
  mutation UpdateUser($updateUserId: ID!, $updates: UserUpdates!) {
    updateUser(id: $updateUserId, updates: $updates) {
      ...FragmentUser
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.UpdateUserMutation,
    models.User,
    'updateUser'
  >('updateUser', fragments.user.TRANSFORMER),
)

export const executor = graphql.createExecutor<
  graphql.schema.UpdateUserMutation,
  models.User,
  graphql.schema.UpdateUserMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
